import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { get_status } from "../../../../../api/statusApis";
import CustomTextField from "../../../../../components/custom_text_field/CustomTextField";
import CustomAutoCompleteDropdown from "../../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown";

import "./expenseFilterStyle.css";

function ExpenseFilter({ searchFilter }) {
  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    fetchStatusList();
  }, []);

  const fetchStatusList = () => {
    get_status()
      .then((response) => {
        const options = response.map((item) => ({
          label: item.status_name,
          value: item.id,
        }));
        setStatusOptions(options);
      })
      .catch((error) => console.log(error));
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      status_id: "",
    },
    onSubmit: (values) => {
      searchFilter(values);
    },
  });

  const resetFilter = () => {
    formik.resetForm();
    searchFilter(null);
  };

  return (
    <div className="expense_filter_main_container">
      <form id="expenseFilterform" onSubmit={formik.handleSubmit}>
        <div className="expense_filter_sub_container">
          {/* Name Filter */}
          <div>
            <CustomTextField
              name="name"
              placeholder="Enter name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
            />
          </div>

          {/* Status Filter */}
          <div>
            <CustomAutoCompleteDropdown
              name="status_id"
              placeholder="Select a status"
              options={statusOptions}
              onChange={(event, newValue) =>
                formik.setFieldValue("status_id", newValue ? newValue.value : "")
              }
              onBlur={formik.handleBlur}
              value={
                statusOptions.find(
                  (status) => status.value === formik.values.status_id
                ) || null
              }
            />
          </div>

          {/* Actions */}
          <div className="expense_filter_actions">
            <button
              type="button"
              className="expense_filter_action_reset"
              onClick={resetFilter}
            >
              Reset
            </button>
            <button
              type="submit"
              className="expense_filter_action_search"
              form="expenseFilterform"
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ExpenseFilter;
